import { notificationStates } from "../reducers/notificationStates";

const NEW_NOTIFICATION = "NEW_NOTIFICATION";
const STATE_NOTIFICATION = "STATE_NOTIFICATION";

const newNotificationAction = (data) => {
  return {
    type: NEW_NOTIFICATION,
    data,
  };
};

const stateNotificationAction = (id, state) => {
  return {
    type: STATE_NOTIFICATION,
    id,
    state,
  };
};

const newNotification = (notification) => {
  return (dispatch) => {
    notification.state = notificationStates.NOT_SHOW;
    dispatch(newNotificationAction(notification));
  };
};

const stateNotificatio = (id, state) => {
  return (dispatch) => {
    dispatch(stateNotificationAction(id, state));
  };
};

export { NEW_NOTIFICATION, newNotification, STATE_NOTIFICATION, stateNotificatio };
